import AdminDashboardProfile from "./AdminDashboardProfile/AdminDashboardProfile";
import AdminDashboardUsers from "./AdminDashboardUsers/AdminDashboardUsers";
import AdminDashboardProducts from "./AdminDashboardProducts/AdminDashboardProducts";
import AdminDashboardRequests from "./AdminDashboardRequests/AdminDashboardRequests";
import AdminDashboardNews from "./AdminDashboardNews/AdminDashboardNews";

const AdminDashboard = () => {
  return (
    <>
      <div className="2xl:w-[85%] xl:w-[75%] lg:w-[70%] w-full h-screen">
        <div className="flex w-full h-full justify-center items-center bg-mainBackground relative">
          {/* Profile Admin Page */}
          <AdminDashboardProfile />
          {/* Users Admin Page */}
          <AdminDashboardUsers />
          {/* Products Admin Page */}
          <AdminDashboardProducts />
          {/* Requests Admin Page */}
          <AdminDashboardRequests />
          {/* News Admin Page */}
          <AdminDashboardNews />
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
